<script>
    export let data;
    import { Button } from "carbon-components-svelte";
    import TrashCan20 from "carbon-icons-svelte/lib/TrashCan20";
    import EnumStatus from "../services/taskstatus";
    import { updateTask } from "../store";

    function updateTaskDo() {
        data.status = EnumStatus.DONENOTCOMPLETE;
        data = data;
        updateTask(data);
    }

    //let taskid = data.id;
</script>

<Button
    kind="danger-ghost"
    iconDescription="Delete"
    aria-label="Delete"
    on:click={updateTaskDo}
    icon={TrashCan20}
/>
